import React from "react";
import "./css/tareas.css"; // Optional, for styling

function Tareas() {
  return (
    <div>
      <h2>Tareas Module</h2>
      <p>This is the Tareas view.</p>
    </div>
  );
}

export default Tareas;
